export const name = 'dynamicPages' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const DynamicPagesResponseHandlerSymbol = Symbol('DynamicPagesResponseHandlerSymbol')
export const PermissionsHandlerSymbol = Symbol('PermissionsHandler')
export const PermissionsHandlerProviderSymbol = Symbol('PermissionsHandlerProvider')
